(function () {
  'use strict';

  function initCarousel(el) {
    var allBlocks = el.querySelectorAll('.rs-carousel__slide');
    if (!allBlocks.length) return;

    var slides = Array.from(allBlocks);
    var track = el.querySelector('.rs-carousel__track');
    var dots = Array.from(el.querySelectorAll('.rs-carousel__dot'));
    var prevBtn = el.querySelector('.rs-carousel__arrow--prev');
    var nextBtn = el.querySelector('.rs-carousel__arrow--next');

    var transition = el.dataset.transition || 'slide';
    var autoplay = el.dataset.autoplay === 'true';
    var speed = parseInt(el.dataset.speed || '5', 10) * 1000;

    var current = 0;
    var total = slides.length;
    var timer = null;
    var touchStartX = 0;
    var isSwiping = false;

    if (total === 0) return;

    function activate(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;

      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = index;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');

      if (transition === 'slide' && track) {
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
      }
    }

    function next() { activate(current + 1); }
    function prev() { activate(current - 1); }

    function startTimer() {
      if (!autoplay || total < 2) return;
      clearInterval(timer);
      timer = setInterval(next, speed);
    }

    function stopTimer() {
      clearInterval(timer);
      timer = null;
    }

    // Init
    slides[0].classList.add('is-active');
    if (dots[0]) dots[0].classList.add('is-active');

    // Arrow buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopTimer(); prev(); startTimer();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopTimer(); next(); startTimer();
      });
    }

    // Dot clicks
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopTimer(); activate(i); startTimer();
      });
    });

    // Touch swipe with live drag feedback
    el.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      isSwiping = true;
      if (transition === 'slide' && track) {
        track.style.transition = 'none';
      }
      el.classList.add('is-dragging');
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      if (!isSwiping || transition !== 'slide' || !track) return;
      var dragOffset = e.touches[0].clientX - touchStartX;
      var basePercent = current * 100;
      var dragPercent = (dragOffset / el.offsetWidth) * 100;
      track.style.transform = 'translateX(' + (-basePercent + dragPercent) + '%)';
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
      if (!isSwiping) return;
      isSwiping = false;
      el.classList.remove('is-dragging');
      if (transition === 'slide' && track) {
        track.style.transition = '';
      }
      var delta = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(delta) > 44) {
        stopTimer();
        if (delta > 0) next(); else prev();
        startTimer();
      } else if (transition === 'slide' && track) {
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
      }
    }, { passive: true });

    // Keyboard navigation
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stopTimer(); prev(); startTimer(); }
      if (e.key === 'ArrowRight') { stopTimer(); next(); startTimer(); }
    });

    // Pause autoplay on hover
    el.addEventListener('mouseenter', stopTimer);
    el.addEventListener('mouseleave', startTimer);

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopTimer(); else startTimer();
    });

    startTimer();
  }

  // Init all carousels on page
  function init() {
    document.querySelectorAll('.rs-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
